import { render } from "./ApplicationVideo.vue?vue&type=template&id=4603db50&scoped=true"
import script from "./ApplicationVideo.vue?vue&type=script&lang=js"
export * from "./ApplicationVideo.vue?vue&type=script&lang=js"

import "./ApplicationVideo.vue?vue&type=style&index=0&id=4603db50&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4603db50"]])

export default __exports__